import React, { useState } from 'react';
import { useForm } from "react-final-form";
import styled from 'styled-components';
import { Modal } from "ui-kit/Modal";
import { Select } from "ui-kit/PrimitiveControls/Select";
import { Contributor, Roles, Instruments } from "types/contributor";
import { FormValues } from "components/NewRelease/ReleaseInfo/types";
import MultiSelectDropdown from 'components/Authors/components/MultiSelectDropdown';
import IntlStore from 'stories/IntlStore';
import { FormattedMessage } from "react-intl";

interface AddContributorModalProps {
  isOpen: boolean;
  onHide: () => void;
  contributorCreating: boolean;
  contributors: Contributor[];
  roles: Roles[];
  name: string;
  instruments: Instruments[];
  createContributor: any;
}

export const AddContributorModal: React.FC<AddContributorModalProps> = props => {
  const { isOpen, onHide, contributorCreating, createContributor, contributors, roles, instruments } = props;
  const [selectedContributor, setSelectedContributor] = useState<string>('');
  const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
  const [selectedInstruments, setSelectedInstruments] = useState<number[]>([]);

  const { change, getState } = useForm<FormValues>();
  const values = getState().values;

  const onCreateContributor = async () => {
    let contributor = contributors.find((c) => c.id === selectedContributor);

    if (!contributor) {
      try {
        contributor = await createContributor(selectedContributor, selectedRoles, selectedInstruments);
      } catch (error) {
        console.error('Error creating contributor:', error);
        return;
      }
    }
    if (!contributor) return;

    const mappedRoles = roles.filter(r => selectedRoles.includes(Number(r.id)));
    const mappedInstruments = instruments.filter(i => selectedInstruments.includes(Number(i.id)));

    change('contributors', [
      ...(values.contributors || []),
      {
        id: contributor.id,
        name: contributor.name,
        title: contributor.name || '',
        roles: mappedRoles,
        instruments: mappedInstruments,
      },
    ]);

    setSelectedRoles([]);
    setSelectedInstruments([]);
    setSelectedContributor('');
    onHide();
  };

  return (
    <Modal
      visible={isOpen}
      className="no-mobile-margin"
      onHide={()=>{onHide(), setSelectedContributor(''), setSelectedRoles([]), setSelectedInstruments([])}} 
      dismissableMask
      showHeader={false}
      header={null}
    >
      <FormContainer>
        <Section>
          <Select
            addAsNew
            editable
            text={'Create new contributor'}
            name="contributor"
            label="Contributor"
            value={selectedContributor}
            filterPlaceholder="Enter contributor name to search"
            items={contributors.map(contributor => ({
              label: contributor.name,
              value: contributor.id
            }))}
            onChange={(e) => setSelectedContributor(e.target.value)}
            placeholder="Select contributor"
          />
        </Section>
        <Section>
          <SelectTitle>
            <FormattedMessage
              id="Authors.Roles"
              defaultMessage="Roles"
            />
          </SelectTitle>
          <MultiSelectDropdown
            title={IntlStore.intl.formatMessage({
              id: "Authors.SelectRoles",
              defaultMessage: "Select roles"
            })}
            searchPlaceholder={IntlStore.intl.formatMessage({
              id: "Authors.EnterRoleName",
              defaultMessage: "Enter role name to search"
            })}
            options={roles.map(role => ({ id: Number(role.id), name: role.name }))}
            setData={setSelectedRoles}
            data={selectedRoles}
          />
        </Section>
        <Section>
          <SelectTitle>
            <FormattedMessage
              id="Authors.Instruments"
              defaultMessage="Instruments"
            />
          </SelectTitle>
          <MultiSelectDropdown
            title={IntlStore.intl.formatMessage({
              id: "Authors.SelectInstruments",
              defaultMessage: "Select instruments"
            })}
            searchPlaceholder={IntlStore.intl.formatMessage({
              id: "Authors.EnterInstrument",
              defaultMessage: "Enter instrument name to search"
            })}
            options={instruments.map(inst => ({ id: Number(inst.id), name: inst.name }))}
            setData={setSelectedInstruments}
            data={selectedInstruments}
          />
        </Section>
        <Box>
          <Add onClick={()=>{onCreateContributor(), onHide()}} >
            Add Contributor
          </Add>
          </Box>
          </FormContainer>
        </Modal>
        );
};

const FormContainer = styled.div`
  width: 490px;
  padding: 16px 0 0;

  /* Mobile: fit dialog into viewport and allow scrolling within content */
  @media (max-width: 768px) {
    width: min(100%);
    max-height: calc(100dvh - 180px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 20px;
 

  &:last-child {
    margin-bottom: 0;
  }
`;

const SelectTitle = styled.div`
  font-family: SF Pro Display;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #000000;
`;
const Box = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0 16px 16px;
`
const Add = styled.div`
  opacity: 1;
  border-radius: 8px;
  padding: 8px 20px 9px 21px;
  background-color: #6777FF;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
  cursor: pointer;


`     